import CustomMargin from "../../../components/custom-margin";
import EyeIcon from "../../../assets/eye-vision.svg";
import TargetIcon from "../../../assets/target-mission.svg";
import HandIcon from "../../../assets/hand-values.svg";

export default function MissionSection() {
    return (
        <section className="my-20">
            <CustomMargin>

                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-zinc-700 via-zinc-300 to-zinc-700 p-[1px] shadow-[0_0_30px_rgba(255,255,255,0.08)]">

                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-[#181818] via-[#101010] to-black">

                        {/* Metallic shine */}
                        <div className="absolute inset-0 bg-[linear-gradient(120deg,transparent_15%,rgba(255,255,255,.05)_45%,transparent_80%)] pointer-events-none" />

                        {/* Top glow */}
                        <div className="absolute top-0 left-0 h-20 w-full bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

                        <div className="relative z-10 px-8 py-12 lg:px-12">

                            <div className="grid lg:grid-cols-3">

                                {/* Mission */}
                                <div className="flex flex-col items-center text-center px-8 py-8">

                                    <h2 className="font-fontMontserrat text-3xl tracking-[0.25em] text-white">
                                        MISSION
                                    </h2>

                                    <div className="my-5 h-px w-16 bg-gradient-to-r from-transparent via-zinc-400 to-transparent" />

                                    <p className="text-zinc-400 leading-8">
                                        Quilaton Law Office aims to provide affordable and seamless legal
                                        services to our clients by effectively combining our highly
                                        diverse and specialized legal skills and passion to serve the
                                        people—locally and globally.
                                    </p>

                                </div>

                                {/* Divider */}
                                <div className="hidden lg:block absolute left-1/3 top-12 bottom-12 w-px bg-gradient-to-b from-transparent via-zinc-700 to-transparent" />

                                {/* Vision */}
                                <div className="flex flex-col items-center text-center px-8 py-8 border-y border-zinc-800 lg:border-0">

                                    <h2 className="font-fontMontserrat text-3xl tracking-[0.25em] text-white">
                                        VISION
                                    </h2>

                                    <div className="my-5 h-px w-16 bg-gradient-to-r from-transparent via-zinc-400 to-transparent" />

                                    <p className="text-zinc-400 leading-8">
                                        The Quilaton Law Office envisions a future where our law firm
                                        is among the superior law firms in the country capable of
                                        providing timely but top-notch services to our growing clients.
                                    </p>

                                    <p className="mt-5 text-zinc-400 leading-8">
                                        Our law firm will continuously be the avenue for clients
                                        seeking peace of mind in their legal concerns at an affordable
                                        rate.
                                    </p>

                                </div>

                                {/* Divider */}
                                <div className="hidden lg:block absolute left-2/3 top-12 bottom-12 w-px bg-gradient-to-b from-transparent via-zinc-700 to-transparent" />

                                {/* Core Values */}
                                <div className="flex flex-col items-center text-center px-8 py-8">

                                    <h2 className="font-fontMontserrat text-3xl tracking-[0.25em] text-white">
                                        CORE VALUES
                                    </h2>

                                    <div className="my-5 h-px w-16 bg-gradient-to-r from-transparent via-zinc-400 to-transparent" />

                                    <p className="text-zinc-400 leading-8">
                                        Our core values include collaboration, compassion and empathy,
                                        efficiency, integrity, innovation and sustainability, and
                                        justice.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </CustomMargin>
        </section>
    );
}